/**
 * Trạng thái nộp dự toán
 */
export default {
  /**
   * Chưa nộp
   */
  NotSubmit: 1,

   /**
   * Chờ duyệt
   */
   Waiting: 2,
   /**
    * Gửi trả
    */
   Reject: 3,
   /**
    * Đã kiểm tra
    */
   Complete: 4,
};
